import React, { Component } from 'react';
import _ from 'lodash';

import { ADMIN_STATUS_LIST } from '../utilities/constants';
import { Description } from './Description';
import Information from './modals/common/Information';
import { messageUtility } from '../utilities/messageUtility';
import _masterSlideLoader from '../utilities/masterSlideLoader';

class PartnerCompanyBranchDescription extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isShowPopupWaitingConfirm: false,
    };
  }

  renderDescription = () => {
    const { hasNodata, isSuspended, adminStatus, otherCompany } = this.props;

    if (otherCompany) {
      return this.renderDescriptionOtherCompany();
    }

    if (hasNodata) {
      return this.renderDescriptionHasNoData(adminStatus);
    }
    if (isSuspended) {
      return this.renderDescriptionIsSuspended(adminStatus);
    }
    return this.renderDescriptionNormal(adminStatus);
  };

  renderDescriptionOtherCompany = () => {
    return (
      <Description>
        <p>代行先会社の支店情報の登録・編集はできません。</p>
      </Description>
    );
  };

  renderDescriptionHasNoData = adminsStatus => {
    const { otherCompany, isOneOwnerCompany } = this.props;

    if (_.isUndefined(isOneOwnerCompany)) {
      return null;
    }

    if (isOneOwnerCompany) {
      return (
        <Description>
          <p>一人親方は支店を作成することはできません。</p>
          <p>
            支店を作成するためには
            <span
              className='clickable-text'
              onClick={this.redirectToCompanyPage}
            >
              本社情報タブ
            </span>
            から「一人親方ではない」に変更してください。
          </p>
        </Description>
      );
    }

    switch (adminsStatus) {
      case ADMIN_STATUS_LIST.NOT_SETTING:
        if (!otherCompany) {
          return (
            <Description>
              <p>支店の登録がありません。</p>
              <p>支店の新規作成・編集・停止は企業管理者が行えます。</p>
              <p>
                企業管理者の権限を持つユーザーが設定されていません。「
                <button
                  className='btn-text--sm btn-redirect'
                  onClick={() => this.redirectToRegisterBuildeeManager()}
                >
                  企業管理者申請
                </button>
                」から申請を行ってください。
              </p>
            </Description>
          );
        }
        break;
      case ADMIN_STATUS_LIST.WAITING_CONFIRM:
        if (!otherCompany) {
          return (
            <Description>
              <p>支店の登録がありません。</p>
              <p>支店の新規作成・編集・停止は企業管理者が行えます。</p>
              <p>
                企業管理者の権限を持つユーザーが設定されていません。「
                <button
                  className='btn-text--sm btn-show-popup'
                  onClick={() => this.togglePopUpWaitingConfirm()}
                >
                  企業管理者申請
                </button>
                」から申請を行ってください。
              </p>
            </Description>
          );
        }
        break;
      case ADMIN_STATUS_LIST.IS_CURRENT_ADMIN:
        return (
          <Description>
            <p>支店の登録がありません。</p>
          </Description>
        );
      case ADMIN_STATUS_LIST.IS_NOT_CURRENT_ADMIN:
        return (
          <Description>
            <p>支店の登録がありません。</p>
            <p>支店の新規作成は企業管理者が行えます。</p>
          </Description>
        );
    }
  };

  renderDescriptionIsSuspended = adminsStatus => {
    if (this.props.isOneOwnerCompany) {
      return (
        <Description type='primary'>
          <p>この支店は停止中です。</p>
          <p>
            この協力会社は一人親方に設定されているため、支店の復旧や新規作成をすることができません。
          </p>
          <p>
            支店の復旧や新規作成をするためには、
            <span
              className='clickable-text'
              onClick={this.redirectToCompanyPage}
            >
              会社情報画面
            </span>
            から一人親方の区分を「一人親方ではない」に変更してください。
          </p>
        </Description>
      );
    }

    switch (adminsStatus) {
      case ADMIN_STATUS_LIST.IS_NOT_CURRENT_ADMIN:
        return (
          <Description type='primary'>
            <p>この支店は停止中です。</p>
            <p>支店の復旧は企業管理者が行えます。</p>
          </Description>
        );
      case ADMIN_STATUS_LIST.IS_CURRENT_ADMIN:
        return (
          <Description type='primary'>
            <p>この支店は停止中です。</p>
          </Description>
        );
    }
  };

  redirectToCompanyPage = () => {
    _masterSlideLoader.show('CompanyPreview', {
      state: {
        id: this.props.selectedCompanyId,
      },
    });
  };

  renderDescriptionNormal = adminsStatus => {
    switch (adminsStatus) {
      case ADMIN_STATUS_LIST.IS_CURRENT_ADMIN:
        return (
          <Description>
            <p>
              選択した支店情報の閲覧・編集・停止、および支店の新規作成が行えます。
            </p>
          </Description>
        );
      case ADMIN_STATUS_LIST.IS_NOT_CURRENT_ADMIN:
        return (
          <Description>
            <p>選択した支店情報の閲覧・編集が行えます。</p>
            <p>支店の新規作成・停止は企業管理者が行えます。</p>
          </Description>
        );
      default:
        return '';
    }
  };

  redirectToRegisterBuildeeManager = () => {
    _masterSlideLoader.show('BuildeeManagerRequest', {
      state: {},
    });
  };

  togglePopUpWaitingConfirm = () => {
    this.setState({
      isShowPopupWaitingConfirm: !this.state.isShowPopupWaitingConfirm,
    });
  };

  buildeeManagerApplyingMessage = () => {
    const { buildeeManagerGrantRequestInfo } = this.props;
    const {
      request_user_name,
      target_user_name,
    } = buildeeManagerGrantRequestInfo;
    return (
      <div className='PartnerCompanyBranchDescription__buildee-manager-content'>
        <p>すでに企業管理者の申請中です。</p>
        <div className='PartnerCompanyBranchDescription__buildee-manager-info'>
          <p>
            申請者：
            {request_user_name}
          </p>
          <p>
            企業管理者として登録するユーザー：
            {target_user_name}
          </p>
        </div>
        <p>
          申請結果は、申請者および企業管理者として登録されたユーザーにメールで通知されます。
        </p>
        <p>申請が承認されるまでしばらくお待ちください。</p>
        <br />
        <p>※企業管理者の申請は会社ごとに1人までとなります。</p>
        <p>
          申請が承認されたユーザーは、他のユーザーに対して企業管理者権限の付与を行うことができます。
        </p>
        <p>
          2人目以降を設定したい場合は、利用者詳細・編集画面から他のユーザーの権限を設定してください。
        </p>
      </div>
    );
  };

  render() {
    return (
      <div className='PartnerCompanyBranchDescription'>
        {this.renderDescription()}
        <Information
          rootClassName='PartnerCompanyBranchDescription__buildee-manager'
          title={messageUtility.getMessage('I-000-109')}
          message={this.buildeeManagerApplyingMessage()}
          buttonText={messageUtility.getMessage('I-000-017')}
          visible={this.state.isShowPopupWaitingConfirm}
          onClose={this.togglePopUpWaitingConfirm}
        />
      </div>
    );
  }
}

export default PartnerCompanyBranchDescription;



// WEBPACK FOOTER //
// ./src/components/PartnerCompanyBranchDescription.jsx